<template>
  <div class="locations-multi-pickup mt-110">
    <div class="locations-multi-pickup-wrapper">
      <h3 class="vz-text-align-left">
        Услуги по перевозке груза {{ fromToText }}
      </h3>
      <p>Транспортная компания «Возовоз» предлагает выгодные условия для перевозки грузов по направлению 
      {{ from.name }} — {{ to.name }}.
      </p>
      <p>
        Чтобы заказать перевозку, достаточно оставить заявку на сайте 
        или воспользоваться личным кабинетом. Если вы сделаете заказ через личный кабинет, то получите 
        скидку 10%. 
      </p>
      <p>
        Цена на услуги по перевозке грузов зависит от объёма, веса и дополнительных услуг, 
        которые может выбрать клиент: упаковка, специальный транспорт, скан накладной на выдачу, разбор 
        упаковки при доставке до адреса. Мы поможем организовать перевозку вашего груза быстро и качественно. 
        Вы можете выбрать удобные даты забора и доставки груза при оформлении заявки.
      </p>
      <p>
        Оплата перевозки возможна как онлайн, так и на терминалах приёмки и выдачи груза.
        Минимальная стоимость перевозки по направлению {{ from.name }} — {{ to.name }} составляет от 800 рублей.
        Для получения груза достаточно иметь код выдачи из СМС
      </p>
    </div>
    <img src="/images/pages/locations/multi-pickup.png" alt="">
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useCityStore} from '@/stores/city'

const {from, to} = storeToRefs(useCityStore())

const fromToText = computed(() => {
  return from.value?.prepositional_name2 && to.value?.prepositional_name3
    ? `из ${from.value.prepositional_name2} в ${to.value.prepositional_name3}`
    : `${from.value.name} — ${to.value.name}`
})
</script>

<style lang="scss" scoped>
.locations-multi-pickup {
  gap: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  p {
    margin-bottom: 10px;
  }

  img {
    width: 100%;
  }

  @media only screen and (max-width: $pub-sm) {
    display: flex;
    flex-direction: column;
  }
}
</style>
